module.exports = __webpack_public_path__ + "static/media/Thankyou.b62ffddf.gif";